import React from 'react';
import { AlertCircle } from 'lucide-react';
import PhotoThumbnailSection from './photo-result-card/PhotoThumbnailSection';
import PhotoMetadataFields from './photo-result-card/PhotoMetadataFields';
import PhotoStatusFooter from './photo-result-card/PhotoStatusFooter';

const PhotoResultCard = ({
  result,
  selectedPhotos,
  expandedCards,
  approvedPhotos,
  batchApplying,
  job,
  togglePhotoSelection,
  toggleCardExpansion,
  approvePhoto,
  rejectPhoto
}) => {
  const isExpanded = expandedCards.has(result.photoId);
  const isApproved = approvedPhotos.has(result.photoId);
  const isSelected = selectedPhotos.has(result.photoId);
  const disableSelection = batchApplying || job.applyProgress?.isApplying;

  const cardBorder = isApproved
    ? 'border-green-300'
    : isSelected
    ? 'border-blue-300'
    : 'border-gray-200';

  return (
    <div className={`bg-white rounded-xl border shadow-sm transition-all duration-200 hover:shadow-md ${cardBorder}`}>
      <div className="p-3">
        <div className="flex items-start space-x-4 mb-2">
          <PhotoThumbnailSection
            result={result}
            isSelected={isSelected}
            disableSelection={disableSelection}
            onToggleSelection={() => togglePhotoSelection(result.photoId)}
          />

          <PhotoMetadataFields
            result={result}
            isExpanded={isExpanded}
            isApproved={isApproved}
            onToggleExpand={toggleCardExpansion}
          />
        </div>

        {result.status === 'processed' && (
          <PhotoStatusFooter
            result={result}
            isApproved={isApproved}
            isExpanded={isExpanded}
            onToggleExpand={toggleCardExpansion}
            onApprove={approvePhoto}
            onReject={rejectPhoto}
          />
        )}

        {(result.status === 'failed' || result.status === 'skipped') && result.reason && (
          <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <div className="flex items-start space-x-2">
              <AlertCircle className="h-4 w-4 text-red-600 mt-0.5 flex-shrink-0" />
              <div>
                <span className="text-sm text-red-800 font-medium">
                  {result.status === 'failed' ? 'Processing Failed' : 'Skipped'}
                </span>
                <p className="text-xs text-red-700 mt-1">{result.reason}</p>
              </div>
            </div>
          </div>
        )}

        {result.applyError && (
          <div className="mt-4 p-3 bg-orange-50 border border-orange-200 rounded-lg">
            <div className="flex items-start space-x-2">
              <AlertCircle className="h-4 w-4 text-orange-600 mt-0.5 flex-shrink-0" />
              <div>
                <span className="text-sm text-orange-800 font-medium">Apply Error</span>
                <p className="text-xs text-orange-700 mt-1">{result.applyError}</p>
              </div>
            </div>
          </div>
        )}

        {result.undoError && (
          <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <div className="flex items-start space-x-2">
              <AlertCircle className="h-4 w-4 text-red-600 mt-0.5 flex-shrink-0" />
              <div>
                <span className="text-sm text-red-800 font-medium">Undo Error</span>
                <p className="text-xs text-red-700 mt-1">{result.undoError}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PhotoResultCard;
